import styles from "./styles/Home.module.scss";
import PopularActivityList from "./components/PopularActivityList";
import ActivityDetailModal from ".././components/ActivityDetailModal";
import Navigation from "./components/Navigation";
import CategoryList from "./components/CategoryList";
import Footer from "../components/Footer";
import CreateActivity from "./components/CreateActivity";
import React, { useState } from "react";
import { ActivityListProps } from "../interfaces/ActivityInterface";

export default function Home({ activities, categories }) {
  const [toggleActivityDetail, setToggleActivityDetail] = useState(1);
  const [showActivityDetail, setShowActivityDetail] = useState(activities[0]);

  function setActivityDetail(toggleStatus: number, id: string) {
    setToggleActivityDetail(toggleStatus);
    setShowActivityDetail(activities[parseInt(id) - 1]);
  }
  return (
    <div className={styles.homepage}>
      <div
        className={styles.activity_modal}
        style={{ display: toggleActivityDetail ? "none" : "block" }}
      >
        <ActivityDetailModal
          closeModal={setActivityDetail}
          showActivityDetail={showActivityDetail}
        />
      </div>
      <Navigation></Navigation>
      <CategoryList categories={categories}></CategoryList>
      <PopularActivityList
        activities={activities}
        setActivityDetail={setActivityDetail}
      ></PopularActivityList>
      <CreateActivity />
      <Footer />
    </div>
  );
}
